import { PropsWithChildren, ReactNode } from 'react';

import ActionButtonBase, {
  ActionButtonSizes,
  ActionButtonVariants,
  IActionButtonProps,
} from 'components/action-button';

export const CartDebugActionButton: (
  props: PropsWithChildren<IActionButtonProps>
) => ReactNode = props => (
  <ActionButtonBase
    px="$2"
    py="4px"
    borderRadius="md"
    lineHeight="sm"
    variant={ActionButtonVariants.OUTLINE}
    size={ActionButtonSizes.SMALL}
    {...props}
  />
);
